import BranchDto from "@/models/Branches/BranchDto";

export default class SendJobsViewModel  { 
  isTest = false;
  testEmailAddresses = '';
  // emailSubject: string = '';
  // emailOpeningParagraph: string = '';
  // emailClosingParagraph: string = '';
}